import { Component } from "react"
import PropTypes from "prop-types"
import { kebabCase, map } from "lodash"
import classnames from "classnames"
import { Tooltip } from "@mui/material"
import { InfoOutlined } from "@mui/icons-material"
import Row from "./row"
import CellTooltip from "components/securities-table/cell-tooltip"

export default class CompareTablePanel extends Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      fn: PropTypes.func.isRequired,
      tooltipContents: PropTypes.string,
    })),
    data: PropTypes.array.isRequired,
    panelTitle: PropTypes.string,
    titleTooltipContent: PropTypes.string,
    fixedItemNumber: PropTypes.bool,
  }

  render() {
    const { items, data, columns, panelTitle, titleTooltipContent, fixedItemNumber } = this.props

    return <div className={classnames("compare-panel fixed")}>
      {panelTitle && <div className={classnames("panel-row", { "fixed-item-number": fixedItemNumber })}>
        <div className="panel-title-wrapper">
          <div className="panel-title">{panelTitle}</div>
          {titleTooltipContent && <Tooltip
            className="panel-title-tooltip"
            title={titleTooltipContent}
            classes={{ popper: "panel-title-tooltip-popper", tooltip: "panel-title-tooltip-content" }}
          >
            <div>
              <InfoOutlined />
            </div>
          </Tooltip>}
        </div>
        {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} />)}
      </div>}
      {map(items, ({ label, fn, tooltipContents }, index) => <div key={index} className={classnames("panel-row", { "fixed-item-number": fixedItemNumber })}>
        <div data-test-class={`${kebabCase(label)}-label`} className={classnames("panel-label")}>
          {label}
          {tooltipContents && <CellTooltip contents={tooltipContents} />}
        </div>
        {map(columns, (column, index) => <Row key={index} column={column} data={data} index={index} selector={fn} />)}
      </div>)}
    </div>
  }
}
